import axios from 'axios'
import { PrinterData } from 'src/features/settings/printers-management/PrintersManagementTypes'

export interface Response<T> {
  data: T;
}

const getBaseURL = (): string => {
  const printerInfoData = localStorage.getItem('printerInfo')
  const printerInfo: PrinterData = printerInfoData ? JSON.parse(printerInfoData) : undefined

  if (printerInfo) {
    return `http://${printerInfo.localIp}:2525`
  }

  return ''
}

const axiosInstance = axios.create()

axiosInstance.interceptors.request.use((config) => {
  const baseURL = getBaseURL()

  if (!baseURL) {
    const error = new Error('Impressora não selecionada')
    return Promise.reject(error)
  }

  config.baseURL = baseURL
  return config
}, (error) => Promise.reject(error))

export default axiosInstance
